import { liefershops } from './utils';

let cachedPartnerId = null;
let cachedPartnerData = null;
let fetchPromise = null;

/**
 * Returns the partner ID if the current hostname is a partner domain.
 * Returns null if on the main platform (liefershops.de) or localhost.
 */
export function getPartnerIdFromDomain() {
  return cachedPartnerId;
}

/**
 * Returns the full partner data object (name, logo, etc.) if on a partner domain.
 */
export function getPartnerData() {
  return cachedPartnerData;
}

export function isPartnerDomain() {
  const hostname = window.location.hostname.replace(/^www\./, '');
  return hostname !== 'liefershops.de' && hostname !== 'localhost' && hostname !== '127.0.0.1';
}

/**
 * Fetches partner list and resolves the partner ID for the current domain.
 * Should be called once on app init. Returns a promise.
 */
export function resolvePartnerDomain() {
  if (!isPartnerDomain()) {
    return Promise.resolve(null);
  }

  if (cachedPartnerId !== null) {
    return Promise.resolve(cachedPartnerId);
  }

  if (fetchPromise) {
    return fetchPromise;
  }

  const hostname = window.location.hostname.replace(/^www\./, '').toLowerCase();

  fetchPromise = fetch(liefershops('api/v1/partner/'))
    .then(res => res.json())
    .then(partners => {
      const match = partners.find(p => {
        const d = (p.domain || '').replace(/^www\./, '').toLowerCase();
        return d === hostname;
      });
      if (match) {
        cachedPartnerId = match.id;
        cachedPartnerData = match;
      }
      return cachedPartnerId;
    })
    .catch(() => null);

  return fetchPromise;
}
